module.exports = __webpack_public_path__ + "static/LLW-625d29af152fb5c177c90cb230da8ca5.svg";